
import {
  HIDE_LABEL_SELECTION, RESET_SELECT_LABEL_STATE, SELECT_LABEL_COLOR,
  TOGGLE_LABEL_SELECTION
} from "./select-label-action-types";

export const toggleLabelSelection = () => ({ type: TOGGLE_LABEL_SELECTION });
export const resetSelectLabelState = () => ({ type: RESET_SELECT_LABEL_STATE });
export const selectLabelColor = color => ({ type: SELECT_LABEL_COLOR, color });

export const hideLabelSelection = () => ({ type: HIDE_LABEL_SELECTION });


// WEBPACK FOOTER //
// ./src/modules/select-label/select-label-action-creators.js